'use strict';
var raf = require('./raf-polyfill'),
    caf = require('./caf-polyfill');

/**
 * "Debouncing is quite more precise. Debouncing ensures that exactly one signal is sent for an event that may be happening several times — or even several hundreds of times over an extended period.
 * As long as the events are occurring fast enough to happen at least once in every detection period, the signal will not be sent!"
 *
 * Debouncing function basata sul requestAnimationFrame del browser, laddove presente
 * @param func Funzione da eseguire
 * @param execAsap Se true il segnale dell'evento è inviato all'inizio del detection period, altrimenti alla fine (default)
 * @returns {Function}
 */
function getDebounce(func, execAsap) {
    var requestId;

    return function () {
        var obj = this,
            args = arguments;

        function delayed() {
            if (typeof execAsap === 'undefined' || !execAsap) {
                func.apply(obj, args);
            }

            requestId = null;
        }

        if (requestId) {
            caf(requestId);
        } else if (execAsap) {
            func.apply(obj, args);
        }

        requestId = raf(delayed);
    };
}

module.exports = getDebounce;
